import BaseService from './base-service';
import {serialize} from '../helpers/request';

export default class DeviceFipeService extends BaseService {
    constructor() {
        super('fipe');
    }

    search(query, type) {
        return this.__get(`${this.url}/search?${serialize({q: query, type: type || ''})}`);
    }

    resolve({tipo, marcaId, modeloId}) {
        return this.__get(`${this.url}/resolve?${serialize({type: tipo, marcaId, modeloId})}`);
    }
}
